<template>
<div class="chapter">
<div class="inner_page">
<p class="crt" id="pz2-1">Text Copyright © 2013 Dr. Beverly Ann Browning </p>
<p class="crt" id="pz2-2">
					All rights reserved. No part of this book may be reproduced or transmitted in any
					form or by any means, electronic or mechanical, including photocopying, recording,
					or by any information storage and retrieval system, without permission in writing
					from publisher. </p>
<p class="crt" id="pz2-7">
					Published by: </p>
<table style="border-style:hidden">
<tbody>
<tr>
<td style="vertical-align:top; text-align:center; border-style:hidden">WriteLife</td>
<td style="vertical-align:top; border-style:hidden; text-align:center;">
								Rule of Thumb </td></tr>
<tr>
<td style="vertical-align:top; text-align:center; border-style:hidden;">(An imprint of Boutique of Quality Books Publishing Company)</td>
<td style="text-align:center; border-style:hidden"><a href="http://www.ruleofthumbbiz.com" id="A5CL" target="_blank">www.ruleofthumbbiz.com</a></td>
</tr>
<tr id="tr-z2-4-4">
<td style="text-align:center; border-style:hidden;">
<a href="http://www.writelife.com" id="AL6" target="_blank">www.writelife.com</a> </td>
<td style="vertical-align:top; text-align:center; border-style:hidden"></td>
</tr>
</tbody>
</table>
<p class="crt" id="pz2-13">
					Printed in the United States of America </p>
<p class="crt" id="pz2-14">
					ISBN 978-1-60808-053-3 </p>
<p class="crt" id="pz2-15" style="margin-top:-1.9em;">
					ISBN 978-1-60808-016-8 </p>
<p class="crt" id="pz2-16">
					First Edition </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage.vue?7ca40ff3